import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Newspaper, FolderOpen, FileText,
  Image, Users, MessageSquare, LogOut, Menu, X, HandHeart, ChevronRight
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './AdminLayout.css';

const navItems = [
  { to: '/admin',            label: 'Dashboard',   icon: <LayoutDashboard size={18}/>, end: true },
  { to: '/admin/noticias',   label: 'Notícias',    icon: <Newspaper size={18}/> },
  { to: '/admin/projetos',   label: 'Projetos',    icon: <FolderOpen size={18}/> },
  { to: '/admin/documentos', label: 'Documentos',  icon: <FileText size={18}/> },
  { to: '/admin/galeria',    label: 'Galeria',     icon: <Image size={18}/> },
  { to: '/admin/membros',    label: 'Membros',     icon: <Users size={18}/> },
  { to: '/admin/contatos',   label: 'Contatos',    icon: <MessageSquare size={18}/> },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sideOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon"><HandHeart size={18} /></div>
          <div>
            <span>Instituto</span>
            <strong>Mãos Estendidas</strong>
          </div>
        </div>

        <nav className="sidebar-nav">
          <p className="sidebar-section-label">Menu</p>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={() => setSideOpen(false)}
            >
              {item.icon}
              <span>{item.label}</span>
              <ChevronRight size={14} className="sidebar-chevron" />
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{user?.nome?.charAt(0) || 'A'}</div>
            <div className="sidebar-user-info">
              <strong>{user?.nome || 'Admin'}</strong>
              <span>{user?.email}</span>
            </div>
          </div>
          <button className="sidebar-logout" onClick={handleLogout}>
            <LogOut size={16} />
          </button>
        </div>
      </aside>

      {/* Overlay mobile */}
      {sideOpen && <div className="sidebar-overlay" onClick={() => setSideOpen(false)} />}

      {/* Main */}
      <div className="admin-main">
        <header className="admin-topbar">
          <button className="topbar-menu" onClick={() => setSideOpen(s => !s)}>
            {sideOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          <a href="/" target="_blank" rel="noopener noreferrer" className="topbar-site-link">
            Ver site público ↗
          </a>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
